import { StudyTypes } from 'lib/generated_constants/projects';

export const isOneOnOne = (projectData) =>
  projectData?.studyTypeId === StudyTypes.ONE_ON_ONE;
